import React from 'react'
import Logo from './logo'
import Button from '../Default'
import { makeStyles } from '@material-ui/core/styles'

export default function Index({ children, ...props }) {
  const s = useStyle({})

  return (
    <Button classes={{ root: s.button }} {...props}>
      <Logo className={s.logo} />
      {children}
    </Button>
  )
}

const useStyle = makeStyles({
  button: {
    backgroundColor: '#D8D8D8',
    color: '#4F5B62',
    borderRadius: 25,
    fontWeight: '600',
    minWidth: 200,
    textTransform: 'none',
  },
  logo: {
    position: 'absolute',
    left: 25,
  },
})
